export default Object.freeze({
  Evaluaciones: {
    id: 1,
    name: 'Evaluaciones',
  },
  Intervenciones: {
    id: 2,
    name: 'Intervenciones',
  },
  Admisiones: {
    id: 3,
    name: 'Admisiones',
  },
  Supervisiones: {
    id: 4,
    name: 'Supervisiones',
  },
  NA: {
    id: 5,
    name: 'N/A',
  },
});
